import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import AutocompleteSelect from 'react-select'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import Paper from '@material-ui/core/Paper'
import Select from '@material-ui/core/Select'
import AddIcon from '@material-ui/icons/Add'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import CancelIcon from '@material-ui/icons/Cancel'
import IconButton from '@material-ui/core/IconButton'
import Chip from '@material-ui/core/Chip'
import NoSsr from '@material-ui/core/NoSsr'
import { emphasize } from '@material-ui/core/styles/colorManipulator'
import CustomButton, { LongCustomButton, ExtraLongCustomButton } from '../custom-material/button/Button'
import CustomExpansionPanel from '../custom-material/expansion-panel/ExpansionPanel'
import CustomExpansionPanelActions from '../custom-material/expansion-panel/ExpansionPanelActions'
import CustomExpansionPanelDetails from '../custom-material/expansion-panel/ExpansionPanelDetails'
import CustomTypography from '../custom-material/typography/Typography'
import { EditTitleCustomExpansionPanelSummary } from '../custom-material/expansion-panel/ExpansionPanelSummary'
import { SmallCustomSwitch } from '../custom-material/switch/Switch'
import { cloneDeep, isEmpty, keyBy } from 'lodash'
import { DEFAULT_EMAIL_PREFERENCE, DEFAULT_FILTER } from '../../libs/email-preferences'
import ConfirmDeleteDialog from './ConfirmDeleteDialog'
import NoDrugsMatchFilterDialog from './NoDrugsMatchFilterDialog'

const styles = theme => ({
  expansionPanelSummary: {
    display: 'flex',
    alignItems: 'center',
    '& :last-child': {
      paddingRight: 0
    }
  },
  expansionPanelActions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16
  },
  formControlLabel: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 4
  },
  emailPreferenceName: {
    fontSize: 20
  },
  input: {
    height: 29,
    minWidth: 250,
    backgroundColor: 'white',
    border: '1px solid #131313',
    borderRadius: 2,
    fontSize: 14,
    paddingLeft: 6,
    fontStyle: 'italic'
  },
  switchButton: {
    position: 'absolute',
    right: 105,
    width: 34,
    padding: 5
  },
  switchRoot: {
    width: 34,
    marginRight: 0
  },
  switch: {},
  formControl: {
    width: 250
  },
  editFilterContainer: {
    display: 'flex',
    padding: '16px 16px 10px 16px',
    justifyContent: 'space-between'
  },
  autoCompleteInput: {
    display: 'flex',
    padding: 0,
    width: 315,
    height: 'inherit',
    outline: `1px solid rgba(0, 0, 0, 0.42)`
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
    fontSize: 15,
    '& > div': {
      height: 'auto',
      '& > span': {
        whiteSpace: 'normal',
        lineHeight: 1,
        padding: '5px 12px'
      }
    }
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
    height: 22,
    borderRadius: 11
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08
    )
  },
  noOptionsMessage: {
    padding: theme.spacing(1,2),
    fontSize: 15
  },
  singleValue: {
    fontSize: 15
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 15
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  },
  divider: {
    height: theme.spacing(2)
  },
  selectContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  selectInputRoot: {
    fontSize: 15,
    width: 250,
    height: 36,
    outline: '1px solid rgba(0, 0, 0, 0.42)'
  },
  selectInputRootLong: {
    fontSize: 15,
    width: 300,
    height: 36,
    outline: '1px solid rgba(0, 0, 0, 0.42)'
  },
  selectInput: {
    paddingLeft: 3,
    height: 36
  },
  selectMenu: {
    paddingLeft: 6,
    height: 22,
    display: 'flex',
    alignItems: 'center'
  },
  selectMenuItem: {
    fontSize: 15
  },
  selectMenuItemEmpty: {
    color: 'rgba(0, 0, 0, 0.42)',
    fontSize: 14
  },
  savedFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    backgroundColor: '#C3D8F0',
    borderTop: '1px solid #003368',
    borderBottom: '1px solid #003368'
  },
  savedFilterInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  filterOptionChip: {
    marginLeft: 5,
    borderRadius: 5,
    height: 30
  },
  filterAND: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: 12,
    fontSize: 15,
    paddingTop: 4,
    paddingLeft: 24
  },
  addEmailPreferenceButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 185,
    margin: '0 16px 16px 16px'
  },
  addIcon: {
    width: 20,
    height: 20,
    fontSize: 20,
    borderRadius: 20,
    backgroundColor: '#1EB26A',
    color: 'white'
  },
  helpIcon: {
    marginLeft: 6,
    fontSize: 22,
    color: '#00ACEF'
  },
  saveIcon: {
    color: '#1356A6'
  },
  editIcon: {
    color: 'inherit'
  },
  editButton: {
    marginLeft: 10,
    padding: 12,
    position: 'absolute',
    right: 55,
    color: '#1356A6'
  },
  disabledEditButton: {
    marginLeft: 10,
    padding: 12,
    position: 'absolute',
    right: 55,
    cursor: 'pointer',
    color: '#C0C0C0'
  },
  editFilterButton: {
    position: 'relative',
    height: 30,
    width: 30,
    marginRight: 0,
    marginLeft: 5,
    padding: '0 !important'
  },
  deleteButton: {
    position: 'absolute',
    right: 0,
    paddingRight: '12px !important',
    marginRight: 8
  },
  deleteFilterButton: {
    position: 'relative',
    height: 30,
    width: 30,
    marginRight: 0,
    marginLeft: 5,
    padding: '0 !important'
  },
  deleteIcon: {
    color: '#CF0000'
  }
})

const NoOptionsMessage = (props) => {
  return (
    <CustomTypography
      color='textSecondary'
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </CustomTypography>
  )
}

const inputComponent = ({ inputRef, ...props }) => {
  return <div ref={inputRef} {...props} />
}

const Control = (props) => {
  return (
    <TextField
      fullWidth
      error={!props.children[0].props.hasValue}
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.autoCompleteInput,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps
        }
      }}
      {...props.selectProps.textFieldProps}
    />
  )
}

const Option = (props) => {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component='div'
      style={{
        fontWeight: props.isSelected ? 500 : 400,
        fontSize: 15
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  )
}

const Placeholder = (props) => {
  return (
    <CustomTypography
      color='textSecondary'
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </CustomTypography>
  )
}

const SingleValue = (props) => {
  return (
    <CustomTypography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </CustomTypography>
  )
}

const ValueContainer = (props) => {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>
}

const MultiValue = (props) => {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  )
}

const Menu = (props) => {
  return (
    <Paper elevation={2} style={{marginBottom: 10}} square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  )
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer
}

const formatCategoryForPlaceholder = category => {
  // 3/18/19 per Leigh, want to not do formatting for now, just use value as-is
  return category
}

// for options that are missing labels
const filterCleanup = (filters, suggestions, categories) => {
  filters.forEach(filter => {
    if (!filter.category.label) {
      filter.category.label = (categories.find(x => x.value === filter.category.value) || {}).label
    }

    const oCleanup = filter.options.filter(x => !x.label)
    if (!oCleanup.length) return
    const fSuggestions = keyBy(suggestions[filter.category.value], x => x.value)
    oCleanup.forEach(o => {
      const suggestion = fSuggestions[o.value]
      if (!suggestion) return
      o.label = suggestion.label
    })
  })
  return filters
}
class EmailPreferenceExpansionPanel extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      suggestions: null,
      confirmDeleteDialogOpen: false,
      noMatchDialogOpen: false,
      preferenceWithEmptyResults: null,
      emailPreferencesOnDelete: null,
      nameOfItemToBeDeleted: '',
      typeToBeDeleted: ''
    }

    this.handleEmailPreferenceNameChange = index => event => {
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const emailPreference = cloneDeep(emailPreferences[index])
      emailPreference.name = (event.target || {}).value || ''
      emailPreference.isDirty = true
      emailPreferences[index] = emailPreference
      this.props.updateEmailPreferences(
        emailPreferences,
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || []
      )
    }

    this.handleEditToggle = index => event => {
      event.stopPropagation()
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const emailPreference = cloneDeep(emailPreferences[index])
      emailPreference.editing = true
      emailPreferences[index] = emailPreference
      this.props.updateEmailPreferences(
        emailPreferences,
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || []
      )
    }

    this.handleEmailPreferenceActiveToggle = index => event => {
      event.stopPropagation()
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const emailPreference = cloneDeep(emailPreferences[index])
      const savedPreferenceName = emailPreference.name || ''
      emailPreference.active = !emailPreference.active
      emailPreference.editing = false
      emailPreference.isDirty = false
      emailPreferences[index] = emailPreference
      this.props.saveEmailPreferences(emailPreferences, (this.props.emailPreferences || {}).categories, savedPreferenceName)
    }

    this.addEmailPreference = () => {
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const savedPreferenceName = ''
      emailPreferences.push(DEFAULT_EMAIL_PREFERENCE)
      this.props.saveEmailPreferences(emailPreferences, (this.props.emailPreferences || {}).categories, savedPreferenceName)
    }

    this.removeEmailPreference = index => event => {
      event.stopPropagation()
      const emailPreferences = cloneDeep((this.props.emailPreferences || {}).preferences)
      const nameOfItemToBeDeleted = emailPreferences[index].name
      emailPreferences.splice(index, 1)
      if (isEmpty(emailPreferences)) emailPreferences.push(DEFAULT_EMAIL_PREFERENCE)
      return this.setState({emailPreferencesOnDelete: emailPreferences, confirmDeleteDialogOpen: true, nameOfItemToBeDeleted, typeToBeDeleted: 'preference'})
    }

    this.deleteEmailPreference = (emailPreferencesOnDelete, nameOfItemToBeDeleted) => () => {
      this.props.saveEmailPreferences(emailPreferencesOnDelete, (this.props.emailPreferences || {}).categories, nameOfItemToBeDeleted)
    }

    this.closeConfirmDelete = () => this.setState({confirmDeleteDialogOpen: false, emailPreferencesOnDelete: null, nameOfItemToBeDeleted: '', typeToBeDeleted: ''})

    this.closeNoMatchDialog = () => {
      // clear out the preferenceWithEmptyResults
      this.props.updateEmailPreferences(
        (this.props.emailPreferences || {}).preferences || [],
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || [],
        null
      )
    }

    this.handleCategorySelect = (preferenceIndex, filterIndex) => event => {
      const value = (event.target || {}).value
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const emailPreference = cloneDeep(emailPreferences[preferenceIndex])
      const filter = cloneDeep(emailPreference.filters[filterIndex])
      const category = cloneDeep((this.props.emailPreferences || {}).categories.find(x => x.value === value))
      if (!isEmpty(category)) delete category.options
      filter.category = category
      filter.options = []
      emailPreference.filters[filterIndex] = filter
      emailPreference.isDirty = true
      emailPreferences[preferenceIndex] = emailPreference
      if (value) {
        const categoryOptions = (filter.category || {}).options || []
        const suggestions = {...this.state.suggestions, [filter.category.value]: categoryOptions}
        this.props.updateEmailPreferences(
        emailPreferences,
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || []
      )
        return this.setState({suggestions})
      }
      this.props.updateEmailPreferences(
        emailPreferences,
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || []
      )
    }

    this.handleFilterOptionChange = (preferenceIndex, filterIndex) => value => {
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const emailPreference = cloneDeep(emailPreferences[preferenceIndex])
      const filter = cloneDeep(emailPreference.filters[filterIndex])
      filter.options = value
      emailPreference.filters[filterIndex] = filter
      emailPreference.isDirty = true
      emailPreferences[preferenceIndex] = emailPreference
      this.props.updateEmailPreferences(
        emailPreferences,
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || []
      )
    }

    this.addFilter = index => () => {
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const emailPreference = cloneDeep(emailPreferences[index])
      emailPreference.filters = [...emailPreference.filters, DEFAULT_FILTER]
      emailPreference.isDirty = true
      emailPreferences[index] = emailPreference
      this.props.updateEmailPreferences(
        emailPreferences,
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || []
      )
    }

    this.removeFilter = (preferenceIndex, filterIndex) => () => {
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      let emailPreference = cloneDeep(emailPreferences[preferenceIndex])
      let nameOfItemToBeDeleted = ''
      if (!isEmpty(emailPreference) && !isEmpty(emailPreference.filters)) {
        nameOfItemToBeDeleted = emailPreference.filters[filterIndex].category.label || ''
        emailPreference.filters.splice(filterIndex, 1)
        if (isEmpty(emailPreference.filters)) emailPreference.filters.push(DEFAULT_FILTER)
      }
      emailPreference.isDirty = true
      emailPreferences[preferenceIndex] = emailPreference
      return this.setState({emailPreferencesOnDelete: emailPreferences, confirmDeleteDialogOpen: true, nameOfItemToBeDeleted, typeToBeDeleted: 'filter'})
    }

    this.deleteFilter = emailPreferencesOnDelete => () => {
      this.props.updateEmailPreferences(
        emailPreferencesOnDelete,
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || []
      )
    }

    this.removeFilterOption = (preferenceIndex, filterIndex, optionIndex) => () => {
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const emailPreference = cloneDeep(emailPreferences[preferenceIndex])
      let filter = cloneDeep(emailPreference.filters[filterIndex])
      if (!isEmpty(filter) && !isEmpty(filter.options)) {
        filter.options.splice(optionIndex, 1)
      }
      emailPreference.filters[filterIndex] = filter
      emailPreference.isDirty = true
      emailPreferences[preferenceIndex] = emailPreference
      this.props.updateEmailPreferences(
        emailPreferences,
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || []
      )
    }

    this.savePreferences = preferenceIndex => () => {
      let emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const emailPreference = cloneDeep(emailPreferences[preferenceIndex])
      const savedPreferenceName = emailPreference.name || ''
      emailPreferences = emailPreferences.map(x => ({...x, editing: false, isDirty: false}))
      this.props.saveEmailPreferences(emailPreferences, (this.props.emailPreferences || {}).categories, savedPreferenceName)
    }

    this.cancelEdits = preferenceIndex => () => {
      const emailPreferences = (this.props.emailPreferences || {}).preferences.slice()
      const originalEmailPreferences = (this.props.emailPreferences || {}).originalPreferences.slice()
      emailPreferences[preferenceIndex] = isEmpty(originalEmailPreferences[preferenceIndex]) ? DEFAULT_EMAIL_PREFERENCE : originalEmailPreferences[preferenceIndex]
      this.props.updateEmailPreferences(
        emailPreferences,
        (this.props.emailPreferences || {}).categories || [],
        (this.props.emailPreferences || {}).originalPreferences || [],
        (this.props.emailPreferences || {}).filterResults || []
      )
    }
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const categories = (nextProps.emailPreferences || {}).categories || prevState.categories || []
    const emailPreferences = (nextProps.emailPreferences || {}).preferences || prevState.emailPreferences || []
    const suggestions = prevState.suggestions || {}
    for (let i = 0; i < emailPreferences.length; i++) {
      if (isEmpty(emailPreferences[i])) continue
      for (let j = 0; j < emailPreferences[i].filters.length; j++) {
        if (isEmpty(emailPreferences[i].filters[j]) || isEmpty(emailPreferences[i].filters[j].category) || !emailPreferences[i].filters[j].category.value) continue
        suggestions[emailPreferences[i].filters[j].category.value] = ((categories.find(x => x.value === emailPreferences[i].filters[j].category.value) || {}).options || [])
      }
    }
    const preferenceWithEmptyResults = (nextProps.emailPreferences || {}).preferenceWithEmptyResults
    const noMatchDialogOpen = !isEmpty(preferenceWithEmptyResults)
    return {suggestions, preferenceWithEmptyResults, noMatchDialogOpen}
  }

  render () {
    const { classes, theme, emailPreferences } = this.props
    const {
      suggestions,
      confirmDeleteDialogOpen,
      noMatchDialogOpen,
      preferenceWithEmptyResults,
      nameOfItemToBeDeleted,
      typeToBeDeleted,
      emailPreferencesOnDelete
    } = this.state

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit'
        }
      })
    }

    return (
      <React.Fragment>
        {isEmpty(emailPreferences) || isEmpty(emailPreferences.preferences) ? null : emailPreferences.preferences.map((emailPreference, preferenceIndex) => (
          <CustomExpansionPanel key={preferenceIndex} defaultExpanded>
            <EditTitleCustomExpansionPanelSummary classes={{content: classes.expansionPanelSummary}} expandIcon={<ArrowRightIcon style={{fontSize: 50, right: 0}} />}>
              {emailPreference.editing
                ? <TextField
                  id='emailPreference'
                  spellCheck={false}
                  placeholder={`Email Preference ${preferenceIndex + 1}`}
                  value={emailPreference.name}
                  required
                  error={!emailPreference.name || emailPreferences.preferences.filter((x, i) => x.name && preferenceIndex !== i).map(x => x.name).includes(emailPreference.name)}
                  onClick={e => e.stopPropagation()}
                  InputProps={{classes: {root: classes.input}}}
                  onChange={this.handleEmailPreferenceNameChange(preferenceIndex)}
                />
                : <CustomTypography className={classes.emailPreferenceName}>{emailPreference.name}</CustomTypography>
              }
              <CustomButton className={classes.switchButton} onClick={this.handleEmailPreferenceActiveToggle(preferenceIndex)}>
                <SmallCustomSwitch
                  className={classes.switch}
                  classes={{root: classes.switchRoot}}
                  disableRipple
                  checked={emailPreference.active}
                  // onChange={this.handleEmailPreferenceActiveToggle(preferenceIndex)}
                />
              </CustomButton>
              <IconButton classes={{root: classes.editButton, disabled: classes.disabledEditButton}} onClick={this.handleEditToggle(preferenceIndex)} disabled={emailPreference.editing}>
                <EditIcon className={classes.editIcon} />
              </IconButton>
              {<IconButton className={classes.deleteButton} onClick={this.removeEmailPreference(preferenceIndex)}><DeleteIcon className={classes.deleteIcon} /></IconButton>}
            </EditTitleCustomExpansionPanelSummary>
            <CustomExpansionPanelDetails style={{padding: 0}}>
              {filterCleanup(emailPreference.filters, suggestions, emailPreferences.categories).map((filter, filterIndex) => (
                emailPreference.editing
                  ? <div key={filterIndex} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                    <div className={classes.editFilterContainer}>
                      <FormControl className={classes.formControl} style={{marginRight: 5}}>
                        <Select
                          className={classes.selectInputBase}
                          value={(filter.category || {}).value || ''}
                          onChange={this.handleCategorySelect(preferenceIndex, filterIndex)}
                          MenuProps={{classes: {paper: classes.selectMenuPaper}}}
                          classes={{selectMenu: classes.selectMenu}}
                          required
                          error={!filter.category || isEmpty(filter.category) || !filter.category.label}
                          displayEmpty
                          inputProps={{
                            name: 'category',
                            id: 'category',
                            classes: {
                              root: classes.selectInputRoot
                            }
                          }}
                        >
                          <MenuItem value={''}>
                            <span className={classes.selectMenuItemEmpty}>Choose Category</span>
                          </MenuItem>
                          {(emailPreferences.categories || []).filter(x => !emailPreference.filters.map(y => (y.category || {}).value || '').includes(x.value) || x.value === (filter.category || {}).value).map((x, i) => {
                            return x.label === 'Other Topics'
                              ? <MenuItem className={classes.selectMenuItem} key={i} value={x.value}>
                                <Tooltip title={((x || {}).options || []).map(x => (x || {}).label || '').join(', ')} placement='right'><span style={{width: '100%'}}>{x.label}</span></Tooltip>
                              </MenuItem>
                              : <MenuItem className={classes.selectMenuItem} key={i} value={x.value}>{x.label}</MenuItem>
                          })}
                        </Select>
                      </FormControl>
                      {(filter.category || {}).value && !isEmpty(suggestions) && !isEmpty(suggestions[filter.category.value])
                        ? <div className={classes.root}>
                          <NoSsr>
                            <AutocompleteSelect
                              classes={classes}
                              styles={selectStyles}
                              options={suggestions[filter.category.value]}
                              components={components}
                              value={filter.options}
                              closeMenuOnSelect={false}
                              onChange={this.handleFilterOptionChange(preferenceIndex, filterIndex)}
                              placeholder={`Type or Select ${formatCategoryForPlaceholder(filter.category.label)}`}
                              isMulti
                            />
                          </NoSsr>
                        </div>
                        : <div style={{minWidth: 315}} />
                      }
                      <IconButton className={classes.deleteFilterButton} onClick={this.removeFilter(preferenceIndex, filterIndex)}><DeleteIcon className={classes.deleteIcon} /></IconButton>
                      <br /><br />
                    </div>
                    {emailPreference.filters.length !== filterIndex + 1 ? <span className={classes.filterAND}>AND</span> : null}
                  </div>
                  : <div key={filterIndex} className={classes.savedFilterContainer}>
                    <div className={classes.savedFilterInfo}>
                      <CustomTypography>{(filter.category || {}).label || ''}:</CustomTypography>
                      {isEmpty(filter.options) ? null : filter.options.map((option, optionIndex) => (
                        <Chip
                          key={optionIndex}
                          tabIndex={-1}
                          label={option.label}
                          className={classes.filterOptionChip}
                          onDelete={emailPreference.editing ? this.removeFilterOption(preferenceIndex, filterIndex, optionIndex) : null} // kind of a hack null === no delete icon render
                          deleteIcon={<CancelIcon className={classes.filterOptionChipDelete} />}
                        />
                      ))}
                    </div>
                    {emailPreference.editing
                      ? <div className={classes.savedFilterActions}>
                        <IconButton className={classes.deleteFilterButton} onClick={this.openConfirmDeletePreference}><DeleteIcon className={classes.deleteIcon} /></IconButton>
                      </div>
                      : null
                    }
                  </div>
              ))}
            </CustomExpansionPanelDetails>
            {emailPreference.editing
              ? <CustomExpansionPanelActions className={classes.expansionPanelActions}>
                <div className={classes.expansionPanelActionsLeft}>
                  <LongCustomButton
                    style={{marginRight: 8}}
                    disabled={isEmpty(emailPreference.filters) ||
                      (emailPreference.filters.filter(x => !isEmpty(x.category) && x.category.value && !isEmpty(x.options)) || []).length !== emailPreference.filters.length
                    }
                    onClick={this.addFilter(preferenceIndex)}
                    variant='contained'
                    color='secondary'
                  >
                    Add More Filters
                  </LongCustomButton>
                </div>
                <div className={classes.expansionPanelActionsRight}>
                  <CustomButton
                    style={{marginRight: 8}}
                    onClick={this.cancelEdits(preferenceIndex)}
                    color='default'
                    variant='contained'
                  >
                    Cancel
                  </CustomButton>
                  <LongCustomButton
                    onClick={this.savePreferences(preferenceIndex)}
                    color='secondary'
                    variant='contained'
                    disabled={!emailPreference.isDirty ||
                      (!emailPreference.name || emailPreferences.preferences.filter((x, i) => x.name && preferenceIndex !== i).map(x => x.name).includes(emailPreference.name) ||
                        isEmpty(emailPreference.filters) ||
                        (emailPreference.filters.filter(x => !isEmpty(x.category) && x.category.value && !isEmpty(x.options)) || []).length !== emailPreference.filters.length
                      )
                    }
                  >
                    Save Selection(s)
                  </LongCustomButton>
                </div>
              </CustomExpansionPanelActions>
              : null
            }
          </CustomExpansionPanel>
        ))}
        <ExtraLongCustomButton
          className={classes.addEmailPreferenceButton}
          variant='contained'
          color='primary'
          onClick={this.addEmailPreference}
        >
          <AddIcon className={classes.addIcon} />
          Add Email Preference
        </ExtraLongCustomButton>
        {confirmDeleteDialogOpen
          ? <ConfirmDeleteDialog
            dialogOpen={confirmDeleteDialogOpen}
            handleCloseDialog={this.closeConfirmDelete}
            confirmDelete={typeToBeDeleted === 'preference' ? this.deleteEmailPreference(emailPreferencesOnDelete, nameOfItemToBeDeleted) : this.deleteFilter(emailPreferencesOnDelete)}
            nameOfItemToBeDeleted={nameOfItemToBeDeleted}
            typeToBeDeleted={typeToBeDeleted}
          />
          : null
        }
        {noMatchDialogOpen
          ? <NoDrugsMatchFilterDialog
            dialogOpen={noMatchDialogOpen}
            handleCloseDialog={this.closeNoMatchDialog}
            preferenceWithEmptyResults={preferenceWithEmptyResults}
          />
          : null
        }
      </React.Fragment>
    )
  }
}

EmailPreferenceExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  emailPreferences: PropTypes.object,
  updateEmailPreferences: PropTypes.func,
  saveEmailPreferences: PropTypes.func
}

export default withStyles(styles, {withTheme: true})(EmailPreferenceExpansionPanel)
